import { styled } from '@ghq-abi/design-system';

export const TableScrollArea = styled('div', {
    width: '100%',
    maxHeight: 'max(calc(100vh - 320px), 320px)',
    overflow: 'auto',
    position: 'relative',
    isolation: 'isolate',
    '&::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#cbd5e1',
        borderRadius: '4px',
    },
});
